import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, CardTitle, CardText } from 'reactstrap';
import Icon from '@mdi/react';
import {
    mdiCashSync,
    mdiLoading,
    mdiAccountMultiplePlus,
    mdiTrashCanOutline,
} from '@mdi/js';
import { deletePayment, deleteMembershipPayment } from '../../redux/modules';
import { Field } from 'react-final-form';
import InvoiceListItem from '../InvoiceListItem';
import PaymentListItem from '../PaymentListItem';
import InvoiceField from '../InvoiceField';
import PaymentModesField from '../PaymentModesField';
import PaymentTimesField from '../PaymentTimesField';

import './InvoiceDetails.css';

export default (props) => {
    const {
        invoice, isMembership, paymentName, className, editable,
        onPaymentDeleted, pristine, submitting, isLoadingOne
    } = props;

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { paymentSuccessfullyDeleted } = useSelector(state => state.payments);
    const { membership_paymentSuccessfullyDeleted } = useSelector(state => state.membership_payments);

    const successfullyDeleted = paymentSuccessfullyDeleted || membership_paymentSuccessfullyDeleted;

    const removePayment = payment => {
        if (isMembership)
            return dispatch(deleteMembershipPayment(payment.id));

        // fallback to invoice payment
        dispatch(deletePayment(payment.id));
    };

    useEffect(() => {
        if (successfullyDeleted)
            onPaymentDeleted();
    }, [successfullyDeleted]);

    const invoiceListItem = React.useMemo(() => (
        <InvoiceListItem invoice={ invoice } editable={editable}/>
        ), [invoice, editable]);

    return (
        <Card className={ `InvoiceDetails ${className}` } color="light">
            <CardHeader>
                { invoiceListItem }
            </CardHeader>
            <CardBody>
                <CardTitle tag="h4" className="mt-3">
                    { t('invoices.payments') }
                </CardTitle>
                <CardTitle tag="h5">
                    { !invoice.payments?.length && t('invoices.has_no_payment') }
                </CardTitle>
                { invoice.payments?.map(payment => (
                    <PaymentListItem payment={ payment } actions={ !!paymentName ?
                        <Button onClick={() => removePayment(payment)} color="danger" size="sm">
                            <Icon path={mdiTrashCanOutline} size={1} />
                        </Button> : null
                    }/>
                ))}
            </CardBody>
            {paymentName && (invoice.due > 0) && (
            <CardFooter>
                <Card color="primary" className="text-light mt-4">
                    <CardBody>
                        <CardText>
                            <CardTitle tag="h4" className="d-block text-center">
                                { t('invoices.add_a_payment') }
                            </CardTitle>
                            <Row className="mb-0">
                                <div className="d-none">
                                    <InvoiceField single defaultValue={invoice.id} name={`${paymentName}[invoice_id]`} invoices={ [invoice] } />
                                </div>
                                <Col className="d-flex flex-column align-items-center justify-content-center text-center">
                                    <h5>{ t('payments.mode') }</h5>
                                    <PaymentModesField className="form-control" single fixedWidth name={`${paymentName}[mode]`} />
                                </Col>
                                <Col className="d-flex flex-column align-items-center justify-content-center text-center">
                                    <h5>{ t('payments.amount') }</h5>
                                    <Field className="form-control" component="input" type="number" max={invoice.due} step={0.01} name={`${paymentName}[amount]`} />
                                </Col>
                                <Col className="d-flex flex-column align-items-center justify-content-center text-center">
                                    <h5>{ t('payments.by') }</h5>
                                    <PaymentTimesField className="form-control" single fixedWidth name={`${paymentName}[nb]`} />
                                </Col>
                                <Col className="d-flex flex-column align-items-center justify-content-end text-center">
                                    <Button type="submit" full color="success" disabled={pristine || submitting || isLoadingOne}>
                                        <span>
                                            <Icon path={isLoadingOne ? mdiLoading : mdiAccountMultiplePlus} spin={isLoadingOne ? 1 : 0} size={1} />&nbsp;
                                            {t("common.add")}
                                        </span>
                                    </Button>
                                </Col>
                            </Row>
                        </CardText>
                    </CardBody>
                </Card>
            </CardFooter>
            )}
        </Card>
    )
}
